import { useDraggable } from '@dnd-kit/core';
import CallInGhl from '../CallInGhl';

const money = (n: number | null) => (n == null ? null : n.toLocaleString('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }));
function ageDays(iso: string | null): number | null { if (!iso) return null; const d = (Date.now() - new Date(iso).getTime()) / 86400000; return Number.isFinite(d) ? Math.floor(d) : null; }
function ageColor(days: number | null): string { if (days == null) return 'text-gray-400'; if (days <= 7) return 'text-success'; if (days <= 30) return 'text-warning'; return 'text-primary-500'; }

export interface BoardOpp {
  id: string; name: string; monetary_value: number | null; status: string | null; assigned_to: string | null;
  contact_name: string | null; contact_company: string | null; last_stage_change_at: string | null;
  updated_at: string | null;
  ghl_contact_url?: string | null;
  persona_label: string | null; persona_role: string | null; persona_intent: string | null; persona_status: 'suggested' | 'confirmed' | null;
}
export interface Broker { name: string; initials: string; color: string; }

export default function OpportunityCard({ opp, broker, onClick }: { opp: BoardOpp; broker?: Broker; onClick: () => void }) {
  const { attributes, listeners, setNodeRef, transform, isDragging } = useDraggable({ id: opp.id });
  const dragStyle: React.CSSProperties = {
    borderLeft: `3px solid ${broker?.color || '#D3D1C7'}`,
    transform: transform ? `translate(${transform.x}px, ${transform.y}px)` : undefined,
    opacity: isDragging ? 0.4 : 1,
  };
  const days = ageDays(opp.last_stage_change_at);
  const value = money(opp.monetary_value);
  return (
    <div ref={setNodeRef} {...attributes} {...listeners} onClick={onClick}
      className="bg-white border border-gray-200/70 rounded-xl p-2.5 mb-2 cursor-pointer shadow-[0_1px_2px_rgba(16,24,40,0.04)] transition hover:shadow-md hover:border-gray-300"
      style={dragStyle}>
      <div className="text-[13px] font-medium text-gray-900 leading-tight">{opp.name || 'Untitled'}</div>
      <div className={`text-[13px] mt-0.5 tabular-nums ${value ? 'text-gray-900 font-semibold' : 'text-gray-400'}`}>{value || 'No value'}</div>
      {opp.persona_label && (
        <div className="mt-1.5 flex items-center gap-1 flex-wrap">
          <span className={`text-[11px] font-medium px-2 py-0.5 rounded-full ${opp.persona_status === 'confirmed' ? 'bg-info-wash text-info' : 'bg-gray-100 text-gray-500'}`}>{opp.persona_label}</span>
        </div>
      )}
      {opp.persona_intent && <div className="text-[11px] text-gray-500 mt-1 leading-snug">{opp.persona_intent}</div>}
      <div className="flex items-center justify-between mt-2 pt-1.5 border-t border-gray-100">
        <span className="flex items-center gap-1.5 text-[11px] text-gray-600">
          <span className="w-4 h-4 rounded-full flex items-center justify-center text-[8px] text-white" style={{ background: broker?.color || '#888780' }}>{broker?.initials || '—'}</span>
          {opp.contact_name || opp.contact_company || '—'}
        </span>
        <span className="flex items-center gap-1.5">
          {/* PHONE1: the card drags and opens its drawer - CallInGhl stops its own taps from reaching either. */}
          {opp.ghl_contact_url && <CallInGhl url={opp.ghl_contact_url} variant="icon" />}
          {days != null && <span className={`text-[10px] ${ageColor(days)}`}>{days}d</span>}
        </span>
      </div>
    </div>
  );
}
